import React, { Component } from "react";
import { Avatar } from "material-ui";
import { nameToColor, nameToInitials } from "../utils/userUtils";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import { grey } from "material-ui/colors/index";
import classNames from "classnames";

const styleSheet = theme => ({
    avatar: {
        backgroundColor: grey[500],
        margin: theme.spacing.unit,
        cursor: "pointer"
    },
    avatarSm: {
        width: 40,
        heigth: 40
    },
    avatarMd: {
        width: 60,
        height: 60
    }
});

class UserAvatar extends Component {
    static propTypes = {
        avatarURL: PropTypes.string,
        displayName: PropTypes.string,
        className: PropTypes.string,
        classes: PropTypes.object,
        size: PropTypes.string,
        onClick: PropTypes.func,
        "aria-owns": PropTypes.string,
        "aria-haspopup": PropTypes.string
    };

    static defaultProps = {
        onClick: () => {},
        size: "sm"
    };

    render() {
        const {
            avatarURL,
            displayName,
            classes,
            onClick,
            size,
            className
        } = this.props;

        let sizeClassName = classes.avatarSm;
        if (size === "md") {
            sizeClassName = classes.avatarMd;
        }
        return (
            <Avatar
                className={classNames(sizeClassName, classes.avatar, className)}
                onClick={onClick}
                style={{ backgroundColor: nameToColor(displayName) }}
                src={avatarURL}
                aria-owns={this.props["aria-owns"]}
                aria-haspopup={this.props["aria-haspopup"]}>
                {avatarURL ? undefined : nameToInitials(displayName)}
            </Avatar>
        );
    }
}

export default withStyles(styleSheet)(UserAvatar);



// WEBPACK FOOTER //
// ./src/components/UserAvatar.jsx